var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM4 9.16478L7.75 12.75L14 6.4192L12.8154 5.25L7.72792 10.4116L5.16292 7.97358L4 9.16478Z","fill":"currentColor"}));
}

Check.defaultProps = {"viewBox":"0 0 18 18","fill":"none","style":{"color":"#39424A"}};

module.exports = Check;

Check.default = Check;
